import React from "react";

import { ApolloProvider } from "@apollo/client";
import { RouterProvider } from "react-router-dom";
import { apolloClient } from "services/HttpService";
import router from "./router/router";
import "./styles.scss"

const MeasurementDevicesRoot = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </ApolloProvider>
  );

}

export default MeasurementDevicesRoot;